const DeveloperService = {
  /**
   * Get all logs
   * @param {Object} payload
   * @returns {Object}
   */
  getLogs: async (payload = {}) => {
    const params = Object.keys(payload).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`).join('&');
    const { data, headers } = await ovpFetch(`/developer/logs?${params}`);
    const pagination = {
      max_page: 1,
      current_page: payload.page,
    };

    const { link } = headers;
    if (link) {
      const linkSplit = link.split(',');
      const lastIndex = linkSplit.findIndex(rel => rel.includes('rel="last"'));
      const prevIndex = linkSplit.findIndex(rel => rel.includes('rel="prev"'));
      if (lastIndex > -1) {
        pagination.max_page = parseInt(linkSplit[lastIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10);
      } else if (prevIndex > -1) {
        pagination.max_page = parseInt(linkSplit[prevIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10) + 1;
      }
      pagination.current_page = pagination.max_page < pagination.current_page ? pagination.max_page : pagination.current_page;
    }

    return {
      logs: data,
      pagination,
    };
  },
  /**
   * Get single log
   * @param {String} id
   * @returns {?Object}
   */
  getLog: async (id) => {
    const { data } = await ovpFetch(`/developer/logs/${id}`);
    return data;
  },
};

// eslint-disable-next-line
export { DeveloperService };
